export enum ErrorType {
  AUTHORIZATION = 'authorization',
  GENERIC = 'generic',
}
